/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebworkingtitle3Inputs */

const en_placewebworkingtitle3 = /** @type {(inputs: Placewebworkingtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your place is taking shape`)
};

const de_placewebworkingtitle3 = /** @type {(inputs: Placewebworkingtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Ort entsteht`)
};

/**
* | output |
* | --- |
* | "Your place is taking shape" |
*
* @param {Placewebworkingtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebworkingtitle3 = /** @type {((inputs?: Placewebworkingtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebworkingtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebworkingtitle3(inputs)
	return de_placewebworkingtitle3(inputs)
});
export { placewebworkingtitle3 as "placeWebWorkingTitle" }